import { Navigate, useParams } from 'react-router-dom';

import { useGetMotivo } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveMotivoPage } from '../../shared/saveMotivo';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateMotivoPageInterface {}

const UpdateMotivoPage: React.FC<UpdateMotivoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_motivo)
  const { id } = useParams();
  const { data, isLoading } = useGetMotivo(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_motivo) return <Navigate to="/parametrizacion/motivos" />;

  return <SaveMotivoPage titlePage="Editar Motivo " editMotivo={data.data} />;
};

export default UpdateMotivoPage;
